<section class="mmr-redirect">
  <div class="mmr-redirect-icon__container">
    <i class="fa-light fa-circle-exclamation" style="color: #aa6804"></i>
    <p class="typog-body-bold">If this fixed the issue please</p>
  </div>
  <button class="mmr-redirect-button" (click)="redirectToMMR()">
    <p class="typog-body-bold">cancel your repair booking</p>
    <dgx-components-icon name="arrow-right" size="md"></dgx-components-icon>
  </button>
</section>
